// Maps the current route pathname to the nav item href it should highlight.
// Mirrors the route grouping used by BottomNav (e.g. order detail pages
// highlight "My Orders", stock item detail pages highlight "WWG Store").
export function getActiveNavHref(pathname = "") {
  if (pathname.startsWith("/order")) return "/my-orders";
  if (pathname.startsWith("/my-orders")) return "/my-orders";
  if (pathname.startsWith("/wwg-store")) return "/wwg-store";
  if (pathname.startsWith("/stock-details")) return "/wwg-store";
  if (pathname.startsWith("/my-lists")) return "/my-lists";
  if (pathname.startsWith("/cart")) return "/cart";
  return "";
}

export default getActiveNavHref;
